// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file reaction/reaction_responses.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { Reaction } from './reaction_model_pb';
import { file_reaction_reaction_model } from './reaction_model_pb';

/**
 * Describes the file reaction/reaction_responses.proto.
 */
export const file_reaction_reaction_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    'CiFyZWFjdGlvbi9yZWFjdGlvbl9yZXNwb25zZXMucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0ImQKGEdldFVzZXJSZWFjdGlvbnNSZXNwb25zZRJACgdzdWNjZXNzGAEgASgLMi0uY29tLmdlbS5iZmYuY29udHJhY3QuR2V0VXNlclJlYWN0aW9uc1N1Y2Nlc3NIAEIGCgR0eXBlIkwKF0dldFVzZXJSZWFjdGlvbnNTdWNjZXNzEjEKCXJlYWN0aW9ucxgBIAMoCzIeLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlJlYWN0aW9uQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw',
    [file_reaction_reaction_model]
  );

/**
 * @generated from message com.gem.bff.contract.GetUserReactionsResponse
 */
export type GetUserReactionsResponse = Message<'com.gem.bff.contract.GetUserReactionsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetUserReactionsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUserReactionsSuccess success = 1;
         */
        value: GetUserReactionsSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetUserReactionsResponse.
 * Use `create(GetUserReactionsResponseSchema)` to create a new message.
 */
export const GetUserReactionsResponseSchema: GenMessage<GetUserReactionsResponse> =
  /*@__PURE__*/
  messageDesc(file_reaction_reaction_responses, 0);

/**
 * @generated from message com.gem.bff.contract.GetUserReactionsSuccess
 */
export type GetUserReactionsSuccess = Message<'com.gem.bff.contract.GetUserReactionsSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.Reaction reactions = 1;
   */
  reactions: Reaction[];
};

/**
 * Describes the message com.gem.bff.contract.GetUserReactionsSuccess.
 * Use `create(GetUserReactionsSuccessSchema)` to create a new message.
 */
export const GetUserReactionsSuccessSchema: GenMessage<GetUserReactionsSuccess> =
  /*@__PURE__*/
  messageDesc(file_reaction_reaction_responses, 1);
